function editArticle (id, setCurrentId, stockState, setStockState) {
    setCurrentId(id);
    setStockState({...stockState, addMode: true})
}

export default editArticle;